import React, { Component } from 'react';
import Style from '../licenseManagement.module.css';
import { connect } from 'react-redux';
import { getUsers, getExtensionUsersCount, getDeployedLicensesGrowth, getBreakDowns, getSearchExtensionUserById, unSetLicenseUserListFailMsg, getSearchedExtensionUsers } from '../../store/entities/customers';
import EnterIcon from '../../assets/Enter_Arrow_Right.svg';
import ConfirmPopup from '../common/popover/confirmPopup';
import SelectBox from '../common/selectbox/selectBox';
import GridComponent from '../common/grid/GridComponent';
import ProfileSvg from '../../assets/profile.svg';
import ChartLineBuild from '../charts/ChartLineBuild';
import LMBrowserChartWrapper from '../LMBrowserChartWrapper';
import LoaderWrapper from '../common/LoaderWrapper/LoaderWrapper';
import { isGlobalView } from '../../utilities/config';

let tabs = {
  month: {
    name: "month",
    timespan: 12
  },
  year: {
    name: "year",
    timespan: 5
  },
  day: {
    name: "day",
    timespan: 30
  },
}

class LicenseManagementTab extends Component {

  state = {
    customerChanged: false,
    pageSize: 6,
    filters: {},
    selectedChartTab: tabs.month.name,
    chartFilters: {
      getDataByPeriod: tabs.month.name,
      timespan: tabs.month.timespan,
      getDataByBrowser: 0,
      getDataByOS: 0,
    },
    licenseUserApiFailMsg: {
      icon: '',
      type: 'error',
      title: 'Oops! Something went wrong.',
      description: 'There was an error while fetching the user list. Please try Refreshing the Page.',
      buttons: 'O',
    },
  }

    componentDidMount = () => {
        if (this.props.selectedCustomer) {
            this.populateLMData();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if ((prevProps.selectedCustomer !== this.props.selectedCustomer) && this.props.selectedCustomer) {
            this.populateLMData();
        }
    }

    populateLMData = () => {
        const selectedId = this.props.matchParams.id;
        const defaultCustomerId = this.props.selectedCustomer?.defaultCustomerId;
        const globalView = isGlobalView(this.props.selectedCustomer?.organizationName);
        this.props.getExtensionUsersCount(selectedId, defaultCustomerId, globalView);
        this.props.getDeployedLicensesGrowth(this.state.chartFilters, selectedId, defaultCustomerId, globalView);
        this.props.getBreakDowns(selectedId, defaultCustomerId, globalView);
    }

    onActionClick = (row) => {
        if(!isGlobalView(this.props.selectedCustomer?.organizationName)) {
            return this.props.history.push(
                `/customers/${this.props.selectedCustomer.id}/licensemanagement/${row.id}`,
            )
        }
        else {
            return this.props.history.push(
                `/tenants/${this.props.selectedCustomer.id}/${row.customerId}/licensemanagement/${row.id}`,
            )
        }
    }
    

    usersGridDef = {
        name: 'userList',
        columns: [
        {fieldName: 'name', displayName: 'User', width: '30%', className: Style.boldFont},
        {fieldName: 'created', displayName: 'Detail', dataType: 'date', subType: 'datetime', prefix:'Created At', width: '62%', className: Style.italicFont},
        {fieldName: 'action', displayName: 'Action', dataType: 'image', src: EnterIcon, width: '50px', onClick: this.onActionClick,}
        ]
    }

    getNextPageData = (pageNo, pageSize) => {
        this.setData(pageNo, pageSize);
    }

    getPrevPageData = (pageNo, pageSize) => {
        this.setData(pageNo, pageSize);
    }

    setData = (pageNo, pageSize) => {
        const start = (pageNo - 1) * (pageSize - 1)
        const end = pageNo * pageSize
        this.setState({filters: {offset: start, pageSize: pageSize}}, () => { this.props.getUsers(this.state.filters, this.props.matchParams.id, this.props.selectedCustomer?.defaultCustomerId, isGlobalView(this.props.selectedCustomer?.organizationName)); }) ;
    }

    rowClick = (row) => {}

    handleCustomerChange = () => {
        this.setState({
        customerChanged: false,
        })
    }

    handleSelect = (selectedOption, value) => {
        this.setState({ selectedExtensionUser: selectedOption });
        if (typeof selectedOption.id !== 'string' || (typeof selectedOption.id === 'string' && selectedOption.id === 'allusers')) {
        this.props.getUsers( this.state.filters, this.props.matchParams.id, this.props.selectedCustomer?.defaultCustomerId, isGlobalView(this.props.selectedCustomer?.organizationName));
        } else {
        this.props.getSearchExtensionUserById( selectedOption?.customerId || this.props.matchParams.id, selectedOption.id)
        }
    }

    handleChartTabClick = (tab) => {
        if (tab === this.state.selectedChartTab) {
            return false
        }
        const filters = this.state.chartFilters

        filters.getDataByPeriod = tabs[tab].name
        filters.timespan = tabs[tab].timespan

        this.setState(
        {
            selectedChartTab: tab,
            chartFilters: filters,
        },
        () => {
            this.props.getDeployedLicensesGrowth(
            this.state.chartFilters,
            this.props.selectedCustomer.id,
            this.props.selectedCustomer?.defaultCustomerId,
            isGlobalView(this.props.selectedCustomer?.organizationName),
            )
        },
        )
    }

    handleClose = () => {
        this.props.unSetLicenseUserListFailMsg()
    }

    handleExtensionUserSearch = (searchText) => {
        this.setState({ userSearchText: searchText });
        this.props.getSearchedExtensionUsers(this.props.selectedCustomer.id, searchText, this.props.selectedCustomer?.key, isGlobalView(this.props.selectedCustomer?.organizationName));
    }

    render() {
        const { usersList } = this.props;
        let selectedExtensionUser = null;
        const filters = this.props.viewType === 'chart' ? this.props.chartFilters : this.props.threatFilters
        if (filters && filters.hasOwnProperty('extensionUserId')) {
            let selected = usersList.filter(
                (item) => item.id == filters.extensionUserId,
            )
            selectedExtensionUser = selected[0]
        }

        return (
        <>
            <div className={`${Style.workArea}`}>
                <div className={`${Style.headerContiner} mt-1 p-4 px-5 d-flex`}>
                <div className={`${Style.borderStyle} pl-3`}>
                    <div className={`${Style.activeUsersFontStyle}`}>
                    Deployed Licenses
                    </div>
                    <div className={`${Style.countStyle}`}>
                    {
                        this.props.extensionUserCountLoading ? 
                        <LoaderWrapper loading={this.props.extensionUserCountLoading}  waitForData={false} styles={{ minHeight: '60px'}} isFlex={true} placeholderText={"No license count data"} >
                        </LoaderWrapper>
                        : 
                        this.props.userCount
                    }
                    </div>
                </div>
                </div>
                <div className="chartContainer mt-3" style={{ marginLeft: '0px' }}>
                <div className="chartRow">
                    <div className="outerBox">
                    <span className="headDetails">Deployed Licenses Growth</span>
                    <div className="innerBox" style={{ minHeight: '415px', width: '650px' }}>
                        <div className={`${Style.navbar} pl-1 d-flex`}>
                        <div onClick={() => this.handleChartTabClick(tabs.month.name)} className={` d-flex align-items-center px-3 mx-2 ${ Style.navbarFontStyle } ${ this.state.selectedChartTab === tabs.month.name ? `${Style.navbarSelectedItemStyle} ` : `` }`} > Month </div>
                        <div onClick={() => this.handleChartTabClick(tabs.year.name)} className={`d-flex align-items-center px-3 mx-2 ${ Style.navbarFontStyle } ${ this.state.selectedChartTab === tabs.year.name ? `${Style.navbarSelectedItemStyle} ` : `` }`} > Year </div>
                        <div onClick={() => this.handleChartTabClick(tabs.day.name)} className={`d-flex align-items-center px-3 mx-2 ${ Style.navbarFontStyle } ${ this.state.selectedChartTab === tabs.day.name ? `${Style.navbarSelectedItemStyle} ` : `` }`} > Day </div>
                        </div> 
                        <div style={{position: "relative"}}>
                        <LoaderWrapper loading={this.props.dayChartLoading || this.props.monthChartLoading || this.props.yearChartLoading}  data={this.props.deployedLicensesGrowth} waitForData={true} styles={{ minHeight: '324px' }} isChart={true} placeholderText={"No licenses deployed"} >
                        <ChartLineBuild
                            deployedLicensesGrowth={ this.props.deployedLicensesGrowth ? this.props.deployedLicensesGrowth : null }
                            activeUsers={ this.props.activeUserGrowth && this.props.tokenRoles === 'PixmAdmin' ? this.props.activeUserGrowth : null }
                            name1="Deployed Licenses"
                            name2="Active User"
                            timespan={this.state.chartFilters.timespan}
                            selectedChartTab={this.state.selectedChartTab}
                        />
                        </LoaderWrapper>
                        </div>
                    </div>
                    </div>

                    <div className="outerBox rightChart">
                    <span className="headDetails">Browsers</span>
                    <div className="innerBox" style={{ minHeight: '415px' }}> {this.props.os && this.props.browser && 
                        (this.props.os['legend'].length > 0) && (this.props.browser['legend'].length > 0) ? (
                        <LMBrowserChartWrapper 
                            os={this.props.os}
                            browser={this.props.browser}
                            breakdownsLoading={this.props.breakdownsLoading}
                            breakDownsErrorMsg={this.props.breakDownsErrorMsg}
                        />
                        ) : (
                        <div className="notFound headDetails">
                            <div style={{ marginTop: '34px' }}>No Data Found</div>
                        </div>
                        )}
                    </div>
                    </div>
                </div>
                </div>
            </div>

            <div className={`${Style.workArea} mt-2`}>
                <div className={`${Style.userLicenses}`}>User License</div>
                <div className={`mt-2 ${Style.pixmFilterBar}`}>
                <SelectBox
                    role="CustomerAdmin,PixmAdmin,TenantAdmin"
                    width="20%"
                    optionBoxWidth="300px"
                    selectedOption={
                    !this.state.customerChanged ? selectedExtensionUser : null
                    }
                    options={usersList}
                    defaultOption={usersList[0]}
                    onSelect={this.handleSelect}
                    onSearch={this.handleExtensionUserSearch}
                    icon={ProfileSvg}
                    customerChanged={this.state.customerChanged}
                    handleCustomerChange={this.handleCustomerChange}
                    type="users"
                    showSearch={true}
                />
            </div>
            </div>

            <div className={`${Style.workArea}`}>
                <GridComponent loaderFlag={this.props.loadingUserList} resetOnChange={this.props.selectedCustomer.id} data={this.props.licenseUsers} pageSize={this.state.pageSize} definition={this.usersGridDef} getPrevPageData={this.getPrevPageData} getNextPageData={this.getNextPageData} rowClick={this.rowClick} params={this.props.matchParams.id} />
            </div>
            {this.props.licenseUserListApiFailed && <ConfirmPopup
                details={this.state.licenseUserApiFailMsg}
                onCloseClick={this.handleClose}
            />}
        </>
        );
    }
    }

    const mapStateToProps = (state) => ({
        licenseUsers: state.entities.customers.licenseUsers,
        deployedLicensesGrowth: state.entities.customers.deployedLicensesGrowth,
        loadingUserList: state.entities.customers.loadingUserList,
        extensionUserCountLoading: state.entities.customers.extensionUsersLoading,
        usersList: state.entities.customers.users,
        selectedCustomer: state.entities.customers.selected,
        userCount: state.entities.customers.usersCount,
        licenseUserListApiFailed: state.entities.customers.licenseUserListApiFailed,
        browser: state.entities.customers.browser,
        os: state.entities.customers.os,
        breakdownsLoading: state.entities.customers.breakdownsLoading,
        threatFilters: state.entities.events.threat.filters,
        chartFilters: state.entities.events.chart.filters,
        dayChartLoading: state.entities.customers.dayChartLoading,
        monthChartLoading: state.entities.customers.monthChartLoading,
        yearChartLoading: state.entities.customers.yearChartLoading,
    })

    const mapDispatchToProps = (dispatch) => ({
        getExtensionUsersCount: (selectedId, defaultCustomerId, isGlobalView) => dispatch(getExtensionUsersCount(selectedId, defaultCustomerId, isGlobalView)),
        getUsers: (filters, selectedId, defaultCustomerId, isGlobalView) => dispatch(getUsers(filters, selectedId, defaultCustomerId, isGlobalView)),
        getDeployedLicensesGrowth: (filters, selectedId, defaultCustomerId, isGlobalView) => dispatch(getDeployedLicensesGrowth(filters, selectedId, defaultCustomerId, isGlobalView)),
        getSearchExtensionUserById: (customerId, userId) => dispatch(getSearchExtensionUserById(customerId, userId)),
        getBreakDowns: (selectedId, defaultCustomerId, isGlobalView) => dispatch(getBreakDowns(selectedId, defaultCustomerId, isGlobalView)),
        unSetLicenseUserListFailMsg: () => dispatch(unSetLicenseUserListFailMsg()),
        getSearchedExtensionUsers: (selectedId, searchText, defaultCustomerId, isGlobalView) => dispatch(getSearchedExtensionUsers(selectedId, searchText, defaultCustomerId, isGlobalView)),
    })

export default connect(mapStateToProps, mapDispatchToProps)(LicenseManagementTab)
